import { FooterElementDataType } from '@/components/sections/builder/elements/footer/footer/types';
import InputSlider from '@/components/sections/builder/settings/input-slider';
import InputTab from '@/components/sections/builder/settings/input-tab';
import { useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/shallow';
import SchemeSetting from '@/components/sections/builder/settings/scheme-setting';
import { ElementProps } from '@/components/sections/builder/types';

export default function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setElementData: state.setElementData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const data = element.data as FooterElementDataType;
  return (
    <div>
      <div className='mb-1 text-base font-bold '>Alignment</div>
      <div className='mb-4'>
        <InputTab
          defaultValue={data.alignment}
          options={[
            { label: 'Left', value: 'left' },
            { label: 'Center', value: 'center' },
            { label: 'Right', value: 'right' },
          ]}
          onChange={(v) => {
            builder.setElementData(element.id, {
              alignment: v,
            });
          }}
        />
      </div>
      <div className='mb-1 mt-4 text-sm'>Color Scheme</div>
      <div className='mb-4'>
        <SchemeSetting
          value={data.colorSchemeFooter}
          onChange={(theme) => {
            builder.setElementData(element.id, {
              colorSchemeFooter: theme,
            });
          }}
        />
      </div>
      {/* tempoprary hide */}
      {/* <div className='mt-4 mb-1 text-base font-bold md:mt-4'>Email Signup</div>
      <div className='flex my-3 gap-x-1'>
        <Checkbox
          id='separator'
          className='mx-2'
          checked={data.isShowEmailSignUp}
          onCheckedChange={(checked) => {
            builder.setElementData(element.id, {
              isShowEmailSignUp: !!checked,
            });
          }}
        />
        <label htmlFor='separator'>Show Email Signup</label>
      </div>
      <div className='mt-4 mb-1 text-base font-bold md:mt-4'>Heading</div>
      <TextEditorMinimal
        value={data.headingEmailSignUp}
        onChange={(val) => {
          builder.setElementData(element.id, {
            headingEmailSignUp: val,
          });
        }}
      /> */}
      <div className='mb-1 mt-4 text-base font-bold md:mt-4'>Card Limit</div>
      <InputSlider
        label='Limit'
        value={data.limit || 3}
        min={3}
        max={5}
        onChange={(val) =>
          builder.setElementData(element.id, {
            limit: val,
          })
        }
      />
      <div className='mb-1 mt-4 text-base font-bold md:mt-4'>Spacing</div>
      <InputSlider
        label='Top Margin'
        value={data.topMargin}
        onChange={(val) =>
          builder.setElementData(element.id, {
            topMargin: val,
          })
        }
      />
      <div className='mb-1 mt-4 text-base font-bold md:mt-4'>Section Padding</div>
      <InputSlider
        label='Top padding'
        value={data.topPadding}
        onChange={(val) =>
          builder.setElementData(element.id, {
            topPadding: val,
          })
        }
      />
      <InputSlider
        label='Bottom padding'
        value={data.bottomPadding}
        onChange={(val) =>
          builder.setElementData(element.id, {
            bottomPadding: val,
          })
        }
      />
    </div>
  );
}
